import script from "./FoundChilds.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundChilds.vue?vue&type=script&setup=true&lang=js"

import "./FoundChilds.vue?vue&type=style&index=0&id=a357f840&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a357f840"]])

export default __exports__